/**
 * FacturaDigital v4 — Layout behavior
 * Horizontal menu toggle, scroll-based navbar, mobile responsiveness
 */

import { estadoFijo } from './lib/barra-fija.js';

(function () {
  'use strict';

  var MQ_MOBILE = '(max-width: 991.98px)';

  document.addEventListener('DOMContentLoaded', function () {
    initHorizontalMenuToggle();
    initMobileSubmenus();
    initFixedOnScroll();
    initClickOutsideClose();
  });

  function isMobile() {
    return window.matchMedia(MQ_MOBILE).matches;
  }

  function bottomNav() {
    return document.querySelector('.horizontal-menu .bottom-navbar');
  }

  function setMenuOpen(open) {
    var nav = bottomNav();
    var btn = document.querySelector('[data-bs-toggle="horizontal-menu-toggle"]');
    if (!nav) return;
    nav.classList.toggle('header-toggled', open);
    document.body.classList.toggle('fd-menu-open', open);
    if (btn) {
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
  }

  /**
   * Mobile hamburger button toggles the bottom navbar
   */
  function initHorizontalMenuToggle() {
    document.querySelectorAll('[data-bs-toggle="horizontal-menu-toggle"]').forEach(function (btn) {
      btn.setAttribute('aria-expanded', 'false');
      btn.setAttribute('aria-label', 'Abrir menú');
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var nav = bottomNav();
        if (!nav) return;
        setMenuOpen(!nav.classList.contains('header-toggled'));
      });
    });
  }

  /**
   * In mobile view, tapping a section toggles its submenu.
   * Real links inside the submenu navigate (and close the drawer).
   * Parent items with href="#" never jump to the top.
   */
  function initMobileSubmenus() {
    var navItems = document.querySelectorAll('.horizontal-menu .page-navigation > .nav-item');

    navItems.forEach(function (item) {
      var parentLink = item.querySelector(':scope > .nav-link');
      var submenu = item.querySelector('.submenu');

      if (parentLink && parentLink.getAttribute('href') === '#') {
        parentLink.addEventListener('click', function (e) {
          e.preventDefault();
        });
      }

      if (submenu) {
        submenu.querySelectorAll('a[href]').forEach(function (link) {
          link.addEventListener('click', function (e) {
            e.stopPropagation();
            if (isMobile()) setMenuOpen(false);
          });
        });
      }

      item.addEventListener('click', function (e) {
        if (!isMobile()) return;
        if (!submenu) return;
        if (e.target.closest('.submenu')) return;

        if (!item.classList.contains('show-submenu')) {
          navItems.forEach(function (other) {
            other.classList.remove('show-submenu');
          });
        }
        item.classList.toggle('show-submenu');
      });
    });
  }

  /**
   * Fix bottom navbar to top when scrolling past the top navbar (con histéresis:
   * lib/barra-fija.js). Al fijarla, el contenedor conserva su hueco
   * (_layout.scss): la altura del documento no cambia.
   */
  function initFixedOnScroll() {
    var horizontalMenu = document.querySelector('.horizontal-menu');
    if (!horizontalMenu) return;

    var fija = false;
    var actualizar = function () {
      var debe = estadoFijo(fija, window.scrollY, window.matchMedia('(min-width: 992px)').matches);
      if (debe !== fija) {
        fija = debe;
        horizontalMenu.classList.toggle('fixed-on-scroll', fija);
      }
    };

    window.addEventListener('scroll', actualizar, { passive: true });
    window.addEventListener('resize', actualizar, { passive: true });
    actualizar();
  }

  /**
   * Close mobile menu when tapping outside
   */
  function initClickOutsideClose() {
    document.addEventListener('click', function (e) {
      if (!isMobile()) return;
      var nav = bottomNav();
      if (!nav) return;

      var clickedInsideMenu = e.target.closest('.horizontal-menu');
      var clickedToggler = e.target.closest('[data-bs-toggle="horizontal-menu-toggle"]');

      if (!clickedInsideMenu && !clickedToggler) {
        setMenuOpen(false);
      }
    });
  }
})();
